import React from "react";
import Grid from '@mui/material/Grid2';
import { Divider } from "@mui/material";
import ViewsTabs from "./ViewsTabs";
import Breadcrumb from "@common/components/ListDetailViews/common/Breadcrumb";

import { BreadcrumbProps as BreacrumbsPropsType } from "../../common/Breadcrumb/types";

const NavigationBar = ({
  BreadcrumbProps = {},
}: {
  BreadcrumbProps?: BreacrumbsPropsType;
}) => {
  return (
    <Grid>
      <Grid
        container
        direction="row"
        sx={{ width: '100%', alignItems: "center",
          justifyContent: "space-between",
          height: "100%",
          paddingRight: 2 }}>
        <Grid>
          <Grid
            container
            sx={{ width: '100%', alignItems: "center",
              justifyContent: "space-between" }}>
            <Breadcrumb {...BreadcrumbProps} />
          </Grid>
        </Grid>
        <ViewsTabs />
      </Grid>
      <Divider orientation="horizontal" />
    </Grid>
  );
};

export default NavigationBar;
